import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ModalService } from '../../shared/modules/modal/modal.service';
import { PlanningDataService, PlanningFormService } from '../../shared/services';

import { ClosableModal } from '../../shared/modules/modal';
import { Projection, PlanningEntity, PlanningFormStatus } from '../../shared/models';

@Component({
  selector: 'planning-financial-modal',
  templateUrl: './planning-financial-modal.component.html',
  styleUrls: ['./planning-financial-modal.component.css']
})
export class PlanningFinancialModalComponent extends ClosableModal implements OnInit {

  scenarioSubscription: Subscription;
  planningFormSubscription: Subscription;
  scenario;
  entities: PlanningEntity[];
  activeProjection: Projection;
  activeEntity: PlanningEntity;
  primaryEntity: PlanningEntity;
  data;
  activeTab;
  formStatus: PlanningFormStatus;

  constructor(
    protected modalService: ModalService,
    private _planningDataService: PlanningDataService,
    private _planningFormService: PlanningFormService
  ) {
    super(modalService);
  }

  ngOnInit() {
    this.activeEntity = this.data.entity;
    this.scenarioSubscription = this._planningDataService.getScenarioObservable().subscribe(scenario => {
      if (this.scenario !== scenario) {
        this.scenario = scenario;
        if (this.scenario.projections && this.scenario.projections.length > 0) {
          this.runInit();
          if (!this.formStatus) {
            this.formStatus = this._planningFormService.createNewForm();
          }
          this._planningFormService.updateFormStatus(this.formStatus);
        }
      }
    });

    this.planningFormSubscription = this._planningFormService.getFormStatusObservable().subscribe(formStatus => {
      this.formStatus = formStatus;
    });
  }

  changeProjectionPair(activeEntity) {
    this.activeProjection = this.scenario.projections.find((projection) => {
      if (projection.srcEntity.entityName === activeEntity || projection.dstEntity.entityName === activeEntity) {
        return projection;
      }
    });
    this.setFormStatus();
  }

  getPrimaryEntity() {
    if (this.activeProjection.srcEntity.isPrimaryEntity) {
      this.primaryEntity = this.activeProjection.srcEntity;
    }

    if (this.activeProjection.dstEntity.isPrimaryEntity) {
      this.primaryEntity = this.activeProjection.dstEntity;
    }
  }

  findActiveProjection() {
    this.scenario.projections.forEach((projection) => {
      if (projection.dstEntity.entityName === this.activeEntity.entityName) {
        this.activeProjection = projection;
      }
      if (projection.srcEntity.entityName === this.activeEntity.entityName) {
        this.activeProjection = projection;
      }
    });
  }

  populateEntities() {
    this.entities = [];
    this.scenario.projections.forEach((projection) => {
      if (this.entities.filter((entity) => entity.entityName === projection.srcEntity.entityName).length === 0 && !projection.srcEntity.isPrimaryEntity) {
        this.entities.push(projection.srcEntity);
      }
      if (this.entities.filter((entity) => entity.entityName === projection.dstEntity.entityName).length === 0 && !projection.dstEntity.isPrimaryEntity) {
        this.entities.push(projection.dstEntity);
      }
    });
  }

  setFormStatus() {
    this.formStatus = this.activeProjection.formStatus;
  }

  runInit() {
    this.findActiveProjection();
    this.populateEntities();
    this.getPrimaryEntity();
    this.setFormStatus();
  }

  exitModal(): void {
    this.closeAllModals();
  }

  saveName() {
    this.success();
  }

  onTabSelected(tabIndex: number): void {
    this.activeTab = tabIndex;
  }

}
